import Container from '@/components/Container/Container';
import { SBImage } from '@/components/ImageService/SBImage';
import { Typography, getColor } from '@/shared';
import { ColorContext } from '@/shared/providers/ColorContext';
import { ProjectsStoryblok } from '@/shared/types/storyblok/storyblok-types';
import clsx from 'clsx';
import Link from 'next/link';
import { useContext, useState } from 'react';
import styles from '../ProjectListing.module.scss';
import SingleCard from '../ui/SingleCard';

interface DesktopProjectListingProps {
    content: ProjectsStoryblok[];
    isDark: boolean;
    loadMoreButton: string;
    startingItems: number;
}

const ProjectListingDesktop: React.FC<DesktopProjectListingProps> = ({
    content,
    isDark,
    loadMoreButton,
    startingItems,
}) => {
    const hexColor = useContext(ColorContext);
    const [shownCount, setShownCount] = useState<number>(startingItems);
    const replaceNumber = (text: string, number: number): string => {
        return text.replace('{number}', String(number));
    };
    const remainingItems = Math.min(1, content?.length - shownCount);

    return (
        <>
            <Container code="fullpage">
                <div className={styles.wrapper}>
                    {content && content.length > 1 ? (
                        content.slice(0, shownCount).map((element: ProjectsStoryblok, index: number) => {
                            const { _uid, mainImage, clientName, title } = element.content;
                            return (
                                <Link
                                    scroll={true}
                                    key={_uid + index}
                                    href={element.full_slug}
                                >
                                    <div className={styles.card}>
                                        {mainImage?.filename && <SBImage image={mainImage} height={256} fit="cover" />}
                                        <div className={styles.infos}>
                                            <div className={clsx({ [styles.space]: !clientName })}>
                                                <Typography.Small className={styles.preTitle}>
                                                    {clientName}
                                                </Typography.Small>
                                            </div>
                                            <Typography.H3 className={styles.title}>{title}</Typography.H3>
                                        </div>
                                    </div>
                                </Link>
                            );
                        })
                    ) : (
                        <SingleCard content={content} isMobile={false} />
                    )}
                </div>
            </Container>
            {shownCount < content?.length && (
                <div
                    className={styles.button}
                    style={{ borderColor: getColor(hexColor, isDark) }}
                    onClick={() => setShownCount((prevState: number) => prevState + startingItems)}
                >
                    {replaceNumber(loadMoreButton, remainingItems)}
                </div>
            )}
        </>
    );
};

export default ProjectListingDesktop;
